import TableCard from './tableCard';

export default TableCard;
